import {Empty, Skeleton} from "antd";
import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import {
  ArrowRightOutlined,
  BankOutlined,
  PictureOutlined
} from "@ant-design/icons";
import {getImageLink} from "../../../../helpers/mainHelpers";
import * as BUCKETS from "../../../../enums/buckets";
import React from "react";
import {useAuth} from "../../../../context/authContext";
import {AboutListProps} from "../../types";
import "./style.less";
import {useNavigate} from "react-router-dom";

const AboutList = ({aboutController}: AboutListProps) => {
  const {aboutList, editButtonHandler, confirmDeleteAboutItem, isLoading} = aboutController;
  const {canManageContent} = useAuth();
  const navigate = useNavigate();

  const navigateToAboutItemPage = (id?: string) => {
    if (id) {
      navigate(`/about/${id}`);
    }
  };

  if (isLoading && !aboutList.length) {
    return <section className="about-section">
      <div className="about-intro"><Skeleton active title={{width: 270}} paragraph={{rows: 2}}/></div>
      <div className="about-grid">
        {Array.from({length: 10}).map((_, index) => <div className="about-skeleton" key={index}>
          <Skeleton.Image active/>
          <Skeleton active title={{width: "82%"}} paragraph={false}/>
        </div>)}
      </div>
    </section>;
  }

  return <section className="about-section">
    <div className="about-intro">
      <div className="about-intro__icon"><BankOutlined/></div>
      <div>
        <div className="about-intro__eyebrow">Про наш заклад</div>
        <h1 className="about-intro__title">Інформація про лікарню</h1>
        <p className="about-intro__description">
          Дізнайтеся більше про структуру, діяльність, історію та основні напрямки роботи закладу.
        </p>
      </div>
    </div>

    {aboutList.length ? <div className={`about-grid ${isLoading ? "about-grid--updating" : ""}`}>
      {aboutList.map((item) => <article className="about-card" key={item.$id || item.title}>
        <button className="about-card__link" type="button" onClick={() => navigateToAboutItemPage(item.$id)}>
          <span className="about-card__media">
            {item.mainImage ? <img
              className="about-card__image"
              alt={item.title}
              src={getImageLink({imageId: item.mainImage, bucketId: BUCKETS.MAIN})}
            /> : <span className="about-card__placeholder"><PictureOutlined/></span>}
            <span className="about-card__overlay"/>
          </span>
          <span className="about-card__content">
            <span className="about-card__label">Детальніше про заклад</span>
            <span className="about-card__title">{item.title}</span>
            <span className="about-card__more">Переглянути <ArrowRightOutlined/></span>
          </span>
        </button>

        {canManageContent && <div className="about-card__admin">
          <ActionsMenu
            label="Дії з матеріалом про заклад"
            onEdit={() => editButtonHandler(item)}
            onDelete={() => confirmDeleteAboutItem(item.$id || "")}
          />
        </div>}
      </article>)}
    </div> : <div className="about-empty">
      <Empty description="Інформаційних матеріалів поки немає"/>
    </div>}
  </section>;
};

export default AboutList;
